import { createSelector } from 'reselect';
import { IState } from '../createStore';

const selectUserInfo = (state: IState) => state.app.persistedState.userInfo;

const selectUserId = createSelector([selectUserInfo], (userInfo) => userInfo?.appUserPk ?? '');
const selectUserProfile = createSelector([selectUserInfo], (userInfo) => userInfo);

export { selectUserId, selectUserProfile };
